// extracted by mini-css-extract-plugin
module.exports = {"container":"JobDetails_component_container__7LmUj","subContainer":"JobDetails_component_subContainer__1n1iO"};